import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useGetDriverPerformance = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onGetDriverPerformanceError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while retrieving driver performance.',
        );
    };

    const onGetDriverPerformanceSuccess = (resetFn: (...args: any) => void, navPath: string, searchParams: string) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        // toast.success(message ?? 'Driver performance retrieved successfully.');
        resetFn();
        navigate(`/${navPath}/${searchParams}`, { state: { data: data } });
    };

    const getDriverPerformance = (searchParams: any, navPath: string, resetFn: (...args: any) => void) => {
        const url: HttpConfig = {
            url: `api/v1/dispatchers?search=${searchParams}`,
            method: 'get',
        };

        request(url, onGetDriverPerformanceSuccess(resetFn, navPath, searchParams), setLoading, onGetDriverPerformanceError);
    };

    return { getDriverPerformance, loading };
};

export default useGetDriverPerformance;
